import { initStats } from "./actions-stats";
import { fetchChargingPoint, fetchCableStatus } from "./actions-status";

export const refreshData = () => {
    initStats()
    fetchChargingPoint();
    fetchCableStatus()
}